<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">
        <v-icon>add</v-icon>
        Add User
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Add User</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12>
                <h3 class="error pa-2 text-white" v-if="this.errorMsg">
                  {{ errorMsg }}
                </h3>
                <h3 class="success pa-2 text-white" v-if="this.successMsg">
                  {{ successMsg }}
                </h3>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Name*"
                  required
                  v-model="newUser.name"
                  :rules="[(v) => !!v || 'Name is required']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Phone Number*"
                  required
                  type="tel"
                  prefix="+88"
                  v-model="newUser.phone"
                  :rules="phoneRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Email*"
                  required
                  v-model="newUser.email"
                  :rules="emailRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="nid"
                  type="text"
                  label="NID"
                  v-model="newUser.nid"
                  :rules="nidRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="password"
                  label="Password*"
                  autocomplete="new-password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  required
                  v-model="newUser.password"
                  :rules="passwordRules"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  label="Investee Supplier*"
                  :items="investeeSuppliers"
                  item-text="title"
                  item-value="id"
                  required
                  v-model="newUser.investee_supplier_id"
                  :rules="[(v) => !!v || 'Investee Supplier is required']"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  clearable
                  label="Loan Product"
                  :items="loanProducts"
                  item-text="product_title"
                  item-value="id"
                  v-model="newUser.loan_product_id"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click="dialog = false">Close</v-btn>
        <v-btn
          color="blue darken-1"
          flat
          :loading="loading"
          :disabled="loading || !valid"
          @click="addUser"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import { loanProductsUrl, addUserUrl } from "@/utils/variables";

  export default {
    data: () => ({
      loading: false,
      dialog: false,
      valid: false,
      showPassword: false,
      errorMsg: "",
      successMsg: "",
      loanProducts: [],
      investeeSuppliers: [
        {
          id: 4,
          title: "Apon",
        },
      ],
      newUser: {
        name: "",
        phone: "",
        email: "",
        password: "",
        nid: "",
        investee_supplier_id: 4,
        loan_product_id: 8,
      },
      phoneRules: [
        (v) => !!v || "Phone Number is required",
        (v) =>
          /^01{1}[3-9]{1}\d{8}$/.test(v) ||
          "Phone Number must be valid Bangladeshi mobile number",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      nidRules: [
        (v) =>
          /(^$)|(^\d{10}$)|(^\d{13}$)|(^\d{17}$)/.test(v) ||
          "NID must have 10, 13 or 17 digits",
      ],
      // nidRules: [
      //   (v) =>
      //     /^[0-9]{10}|[0-9]{13}$/.test(v) ||
      //     "NID must have 10, 13 or 17 digits",
      // ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) =>
          /^[A-Za-z\d]{8,}$/.test(v) || "Password must be minimum 8 characters",
      ],
    }),
    async created() {
      await this.getLoanProducts();
    },
    methods: {
      async getLoanProducts() {
        const { data } = await HTTP().get(loanProductsUrl);
        this.loanProducts = data.data;
        this.loanProducts.forEach((product) => {
          product.product_title = `${
            product.product_title
          } (${product.product_title
            .split(/\s/)
            .reduce((response, word) => (response += word.slice(0, 1)), "")
            .toUpperCase()})`;
        });
      },
      async addUser() {
        try {
          await this.$refs.form.validate();
          if (this.valid) {
            this.loading = true;
            const { data } = await HTTP().post(addUserUrl, this.newUser);
            if (data.error === 1) {
              this.successMsg = "";
              this.errorMsg = data.errorMsg;
            } else {
              this.successMsg = "Successfully Added";
              this.errorMsg = "";

              this.newUser = {
                ...this.newUser,
                name: "",
                phone: "",
                email: "",
                password: "",
                nid: "",
                investee_supplier_id: 4,
                loan_product_id: 8,
              };
              this.$refs.form.resetValidation();
              this.$emit("userAdded");
            }
          }
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>
<style scoped>
  .text-white {
    color: #fff !important;
  }
</style>
